module.exports = "https://vote4-campaigns-cdn.fire-emblem-heroes.com/images/src/assets/images/hero/faces/110069.png";